import { redirect } from "@tanstack/react-router";
import { createMiddleware } from "@tanstack/react-start";

import { CACHE_KEYS, cache } from "@onesolution/utils";

import { getCurrentUserDetails } from "@onesolution/serverFn/user";
import { authMiddleware } from "./auth";
import { mondayBoards } from "./mondayBoards";

export const userServices = createMiddleware({ type: "function" })
	.middleware([authMiddleware, mondayBoards])
	.server(async ({ next, context }) => {
		const { monday_workspace_id, email, sid } = context.user;

		if (!monday_workspace_id || !sid || !email) {
			throw redirect({ to: "/login" });
		}

		const cacheKey =
			CACHE_KEYS.userServices + context.user.sid + context.user.email;

		const servicesIds = await cache.getOrSet<string[] | undefined>(
			cacheKey,
			async () => {
				const userDetails = await getCurrentUserDetails();

				return userDetails?.services?.linked_item_ids;
			},
		);

		return next({
			context: {
				...context,
				user: { ...context.user, servicesIds },
			},
		});
	});
